import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { LobbyScene } from './scenes/LobbyScene';
import { GameScene } from './scenes/GameScene';
import { ResultsScene } from './scenes/ResultsScene';
import { audio } from './core/AudioManager';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: '#1b1030',
  width: 540,
  height: 960,
  scale: {
    mode: Phaser.Scale.FIT,
    // El centrado lo hace el flexbox de `#app` (index.html), no Phaser: su
    // `CENTER_BOTH` calcula un margin-left/top fijo asumiendo que el canvas
    // vive en flujo normal dentro del padre, y ese margin se suma al
    // centrado del flexbox — en desktop el canvas termina desplazado hacia
    // la derecha/abajo en vez de centrado. `NO_CENTER` deja el centrado
    // 100% a cargo del CSS.
    autoCenter: Phaser.Scale.NO_CENTER,
  },
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: 1 },
      debug: false,
    },
  },
  scene: [BootScene, PreloadScene, LobbyScene, GameScene, ResultsScene],
};

const game = new Phaser.Game(config);

// Puente mínimo para e2e/depuración: acceso a la instancia del juego desde
// la consola/Playwright. No afecta el juego (solo lectura/navegación).
(window as unknown as { __vyvGame?: Phaser.Game }).__vyvGame = game;

// Desbloqueo de audio: los navegadores solo permiten crear/reanudar un
// AudioContext en respuesta a un gesto real del usuario. Con el primer toque
// en cualquier parte de la app arrancan los SFX y la música de fondo (si no
// estaba silenciada de una sesión anterior).
window.addEventListener('pointerdown', () => audio.unlock(), { once: true });

// PWA: registra el service worker de cache estático (ver `public/sw.js`) solo
// en producción — en `vite dev` los módulos sin bundlear no conviene
// cachearlos, y así no interfiere con HMR ni con los tests e2e que corren
// contra el servidor de desarrollo. Tras la primera carga en producción
// (build de `npm run build`), la app queda disponible offline.
if (!import.meta.env.DEV && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {
      // el juego funciona igual sin service worker (solo se pierde el
      // soporte offline); no hay que bloquear ni mostrar error al jugador.
    });
  });
}
